import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { nimmAnmeldeZiel } from "@/lib/auth/anmeldeZiel";
import { useAuth } from "@/lib/auth/AuthContext";

type State =
  | { kind: "idle" }
  | { kind: "redirecting" }
  | { kind: "error"; message: string };

export function LoginPage() {
  const { status, signInWithMicrosoft } = useAuth();
  const navigate = useNavigate();
  const [state, setState] = useState<State>({ kind: "idle" });

  // Wer hier landet und bereits eingeloggt ist (z.B. nach einem OAuth-Redirect,
  // der zwischenzeitlich auf /login umgebogen wurde): direkt weiter.
  useEffect(() => {
    if (status === "signed-in") {
      void navigate(nimmAnmeldeZiel() ?? "/", { replace: true });
    }
  }, [status, navigate]);

  async function onClick(): Promise<void> {
    setState({ kind: "redirecting" });
    try {
      await signInWithMicrosoft();
    } catch (err) {
      const message = err instanceof Error ? err.message : "Unbekannter Fehler.";
      setState({ kind: "error", message });
    }
  }

  return (
    <main className="flex min-h-full items-center justify-center p-8">
      <div className="w-full max-w-sm space-y-6">
        <div className="space-y-3 text-center">
          <img
            src="/logo.png"
            alt="Bergler Energie"
            className="mx-auto h-14 w-auto"
            width={56}
            height={56}
          />
          <h1 className="text-2xl font-semibold tracking-tight">Anmelden</h1>
          <p className="text-sm text-muted-foreground">
            Mit deinem Bergler-Microsoft-Konto.
          </p>
        </div>

        <Button
          type="button"
          className="w-full"
          disabled={state.kind === "redirecting"}
          onClick={() => {
            void onClick();
          }}
        >
          {state.kind === "redirecting"
            ? "Weiterleiten..."
            : "Mit Microsoft anmelden"}
        </Button>

        {state.kind === "error" ? (
          <p className="text-center text-sm text-destructive">{state.message}</p>
        ) : null}
      </div>
    </main>
  );
}
